<template>
  <div class="report">
    <default-header />
    <ReportModal
      :price="getTotalPrice(batteries[activeBatterySlide].battery_price, batteries[activeBatterySlide].service_price)"
      :manufacturer="batteries[activeBatterySlide].manufacturer"
      :battery="batteries[activeBatterySlide].model"
      :clientsWantsToDisagree="clientsWantsToDisagree"
      v-if="showRaportModal"
      @close="showRaportModal = false"
      @giveAnswer="giveAnswer()"
    />
    <div v-if="!showThankYouPage" class="innerContent noBottomPadding">
      <div
        class="additionalPadding salutation"
        v-if="client"
      >{{$t('report.salutation', {firstName: client.firstName, lastName: client.lastName})}}<br><br>
        {{ $t('report.theOfferWillLastForXDays') }}
        <template v-if="garageName">
          <br>
          <br>
          {{ garageName }}, {{ $t('notifications.report.yourMechanic') }}
        </template>
      </div>
      <div class="additionalPadding">
        <h2 v-if="vehicleData" class="text-center">{{$t('clientDetails.carDetails')}}</h2>
        <div class="report__resultRow car_details_row" v-if="vehicleData">
          <span>{{$t('clientDetails.car')}}</span>
          <span>{{vehicleData.name}}</span>
        </div>
        <div class="report__resultRow car_details_row" v-if="vehicleData">
          <span>{{$t('general.plates')}}</span>
          <span>{{vehicleData.plates || 'n/a'}}</span>
        </div>
        <div v-if="batteryResult" class="report__result">
          <h2 class="text-center">{{$t('report.title')}}</h2>
          <h3 class="text-center mb-4">{{$t('report.dataOfTest')}} {{ createdAt }}</h3>
          <div class="report__resultRow">
            <TemperatureResult :battery-temperature="batteryResult['temperature_measured']" />
          </div>
          <div class="report__resultRow">
            <font-awesome-icon
              class="blue-icon"
              :icon="['fas', 'dot-circle']"
            />{{$t('testResult.rated')}}<span> {{batteryResult.cca_rated}} {{$t('general.cca')}}</span>
          </div>
          <div class="report__resultRow">
            <VoltageResultComponent :voltage="batteryResult.voltage" />
          </div>
          <div class="report__resultRow">
            <CcaMeasured
              :ccaMeasured="batteryResult['cca_measured']"
              :overallResult="batteryResult['overall_result']"
            />
          </div>
          <CrankingAndReservedResults :currentTestResult="batteryResult" :from="'report'" />

          <h2 class="text-center mt-4 mb-3">{{$t('report.diagnosis')}}</h2>
          <div class="report__resultRow">
            <GeneralDiagnosis :overall-result="batteryResult['overall_result']" />
          </div>

        </div>
      </div>
      <div v-if="batteries.length > 0" class="mb-4 slickContainer">
        <div class="slickArrows" v-if="batteries.length > 1">
          <font-awesome-icon
            @click.capture="$refs.slick.prev()"
            :icon="['fas', 'angle-double-left' ]"
          />
          <font-awesome-icon
            @click.capture="$refs.slick.next()"
            :icon="['fas', 'angle-double-right' ]"
          />
        </div>
        <slick ref="slick" :options="slickOptions" @afterChange="handleAfterChange">
          <div class="testResult__battery" v-for="(battery, index) in batteries" :key="index">
            <h5 v-if="!battery.title" class="testResult__battery__title">{{ '' }}</h5>
            <h5 v-else class="testResult__battery__title">
              {{
              battery.title === 'good' ?
              $t('general.goodModelIs') :
              battery.title === 'best' ?
              $t('general.bestModelIs') :
              $t('general.excellentModelIs')
              }}
            </h5>
            <div
              class="testResult__battery__image"
              v-if="battery.image"
              :style="{backgroundImage: 'url(' + battery.image + ')'}"
            ></div>
            <div
              v-else
              class="testResult__battery__image"
              :style="{backgroundImage: 'url(' + require(`@/assets/battery_placeholder.png`) + ')'}"
            ></div>
            <div class="testResult__battery__name">{{ battery.manufacturer + ' ' + battery.model }}</div>
          </div>
        </slick>
      </div>
      <div v-if="batteries.length > 0" class="additionalPadding">
        <div class="report__batteryDetails">
          <h3 class="text-center">{{$t('report.batteryDetails')}}</h3>
          <div class="report__batteryDetails__row">
            <div class="report__batteryDetails__margin-left">
              <span>{{$t('report.model')}}</span>
              <span>{{batteries[activeBatterySlide].model}}</span>
            </div>
          </div>
          <div v-if="batteries[activeBatterySlide].part" class="report__batteryDetails__row">
            <div class="report__batteryDetails__margin-left">
              <span>{{$t('report.part')}}</span>
              <span>{{batteries[activeBatterySlide].part}}</span>
            </div>
          </div>
          <div
            v-if="batteries[activeBatterySlide].parameters && batteries[activeBatterySlide].parameters.cca"
            class="report__batteryDetails__row"
          >
            <div class="report__batteryDetails__margin-left">
              <span>{{$t('report.cca')}}</span>
              <span>{{batteries[activeBatterySlide].parameters.cca}}</span>
            </div>
          </div>
          <div
            v-if="batteries[activeBatterySlide].parameters && batteries[activeBatterySlide].parameters.cca"
            class="report__batteryDetails__row"
          >
            <div class="report__batteryDetails__margin-left">
              <span>{{$t('report.capacity')}}</span>
              <span
                v-if="batteries[activeBatterySlide].hasOwnProperty('parameters')"
              >{{batteries[activeBatterySlide].parameters.capacity}}</span>
            </div>
          </div>
          <div class="report__batteryDetails__row">
            <div class="report__batteryDetails__margin-left">
              <div>
                <span>{{$t('general.PriceBattery')}}</span>
              </div>
              <span>{{ batteries[activeBatterySlide].battery_price + ' ' }}{{currencyLabel}}</span>
            </div>
          </div>
          <div class="report__batteryDetails__row">
            <div class="report__batteryDetails__margin-left">
              <div>
                <span>{{$t('quote.PriceService')}}</span>
              </div>
              <span>{{ batteries[activeBatterySlide].service_price + ' ' }}{{currencyLabel}}</span>
            </div>
          </div>

          <div class="report__batteryDetails__comment" v-if="batteries[activeBatterySlide].comment">
            <h3 class="text-center mt-2 mb-1">{{$t('report.comment')}}:</h3>
            <div class="pl-3 pr-3">
              <i>
                <span
                  class="report__batteryDetails__comment__text"
                >{{batteries[activeBatterySlide].comment}}</span>
              </i>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!offerAnswered" class="additionalPadding mt-2">
        <button
          class="btn btn-primary btn-block mt-4"
          @click="showRaportModalFunc(false)"
        >{{$t('report.chooseBattery')}}</button>
        <button
          class="btn btn-outline-primary btn-block mt-2 mb-3"
          @click="showRaportModalFunc(true)"
        >{{$t('general.disagree')}}</button>
      </div>

      <!-- Driving pattern -->
      <div v-if="displayDrivingPatternBar && batteryResult">
        <h2 class="text-center mt-3 mb-3">{{$t('general.drivingPattern')}}</h2>
        <div class="report__batteryDetails__row">
          <div class="report__batteryDetails__margin-left">
            <div>
              <span class="clientDetailsRow__text">{{$t('clientDetails.tripsDay')}}</span>
            </div>
            <span>{{ client.drivingPattern.trips }}</span>
          </div>
        </div>
        <div class="report__batteryDetails__row">
          <div class="report__batteryDetails__margin-left">
            <div>
              <span class="clientDetailsRow__text">{{$t('clientDetails.kmDay')}}</span>
            </div>
            <span>{{ client.drivingPattern.distance }}</span>
          </div>
        </div>
        <div class="report__batteryDetails__row margin_item-bottom">
          <div class="report__batteryDetails__margin-left">
            <div>
              <span>{{$t('otherBattery.capacityAh')}}</span>
            </div>
            <span>{{ client.drivingPattern.capacity }}</span>
          </div>
        </div>

        <DrivingPatternBar :result="drivingPatternResult" :message="drivingPatternMessage"></DrivingPatternBar>
      </div>
    </div>
    <div v-else class="report__thankYouPage innerContent">{{$t('general.thankYou')}}</div>
  </div>
</template>

<script>
import { HTTP } from '../http';
import DefaultHeader from '../partials/DefaultHeader';
import Slick from 'vue-slick';
import ReportModal from '../components/ReportModal';
import DrivingPatternBar from '../components/DrivingPatternBar';
import CrankingAndReservedResults from '../components/CrankingAndReservedResults';
import VoltageResultComponent from '../components/VoltageResultComponent';
import CcaMeasured from '../components/CcaMeasured';
import TemperatureResult from '../components/TemperatureResult';
import GeneralDiagnosis from '../components/GeneralDiagnosis';
import { i18n } from '../translations';
import moment from 'moment'

export default {
  name: 'Report',
  components: {
    GeneralDiagnosis,
    TemperatureResult,
    VoltageResultComponent,
    DefaultHeader,
    Slick,
    ReportModal,
    DrivingPatternBar,
    CrankingAndReservedResults,
    CcaMeasured
  },
  data() {
    return {
      drivingPatternMessage: null,
      drivingPatternResult: 0,
      vehicleData: {
        plates: null,
        name: null
      },
      slickOptions: {
        centerMode: true,
        centerPadding: '26%',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
        focusOnSelect: true,
        swipeToSlide: true,
        touchThreshold: 10
      },
      clientsWantsToDisagree: false,
      batteries: [],
      client: null,
      batteryResult: null,
      activeBatterySlide: 0,
      showRaportModal: false,
      createdAt: '',
      showThankYouPage: false,
      currencyLabel: '',
      offerAnswered: false,
      garageName: null,
      language: null,
    };
  },
  computed: {
    displayDrivingPatternBar: function() {
      return !!this.drivingPatternMessage;
    }
  },
  beforeMount() {
    HTTP.get(`/api/reports/${this.$route.params.id}`)
      .then(res => {
        Object.assign(this, res.data.data)
        i18n.locale = this.language
        this.createdAt = moment(this.createdAt).format('YYYY-MM-DD HH:MM')

        if (this.batteryResult.overall_result == null) {
          this.batteryResult.overall_result = this.parseResult(this.batteryResult.test_result);
        }
      })
      .catch(() => {
        this.$router.push({ name: 'NotFoundPage' })
      });
  },
  mounted() {
    $('.paddingToHide').css('padding-left', '0px');
    $('.paddingToHide').css('padding-right', '0px');
  },
  destroyed() {
    $('.paddingToHide').css('padding-right', '15px');
    $('.paddingToHide').css('padding-left', '15px');
  },
  methods: {
    parseResult(result) {
      let valuesMap = [
        {
          value: 2,
          array: ['00', '-0']
        },
        {
          value: 1,
          array: ['01', '-1']
        },
        {
          value: 0,
          array: ['05', '-5', '06', '-6']
        }
      ];

      for (const index in valuesMap) {
        if (valuesMap[index].array.includes(result)) {
          console.log(valuesMap[index]);
          return valuesMap[index].value;
        }
      }

      return 0;
    },
    checkIfTemperatureIsOk(temperature) {
      return (
        (Number(temperature) - Number(this.batteryResult.temperature_rated_max)) *
          (Number(temperature) - Number(this.batteryResult.temperature_rated_min)) <=
        0
      );
    },
    handleAfterChange(event, slick, currentSlide) {
      this.activeBatterySlide = currentSlide;
    },
    showRaportModalFunc(value) {
      this.clientsWantsToDisagree = value;
      this.showRaportModal = true;
    },
    giveAnswer() {
      this.showRaportModal = false;

      HTTP.put(`/api/reports/${this.$route.params.id}`, {
        status: this.clientsWantsToDisagree ? 2 : 1,
        battery_id: this.clientsWantsToDisagree ? null : this.batteries[this.activeBatterySlide].id
      })
      .then(() => {
        this.showThankYouPage = true;
      })
      .catch(() => {
        this.$toasted.show('something wrong');
      })
    },

    getTotalPrice(priceOne, priceTwo) {
      return Number(priceOne) + Number(priceTwo);
    }
  }
};
</script>

<style scoped lang="scss">
$assets: '~@/assets/';
@import '~@/styles/variables';

.report {
  .car_details_row {
    display: flex;
    justify-content: space-between;
    span:nth-of-type(1) {
      font-weight: 500;
    }
  }
  .salutation {
    margin-bottom: 15px;
    margin-top: 15px;
  }
  &__thankYouPage {
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 500;
  }

  .slick-slide {
    padding-top: 30px;
  }

  .slick-arrow {
    position: absolute;
    top: 35px;
    &:last-child {
      right: 0;
    }
  }
  .slickContainer {
    position: relative;
    .slickArrows {
      z-index: 99;
      color: $primary;
      position: absolute;
      top: 32px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 0 16px;
      font-size: 30px;
      svg {
        cursor: pointer;
      }
    }
  }

  .slick-slider {
    background-size: 70%;
    background-repeat: no-repeat;
    background-position: center top;
  }

  .slick-slide.slick-current {
    padding-top: 0;

    .testResult__battery__name {
      white-space: nowrap;
      display: block;
      color: $primary;
      font-weight: 500;
      font-size: 20px;
      svg {
        margin-right: 8px;
      }
    }
    .testResult__battery__title {
      display: block;
    }
    .testResult__battery__image {
      -webkit-transform: scale(1.8);
      transition: all 0.3s;
      background-repeat: no-repeat;
      transform: scale(1.8);
      background-position: center;
    }
  }

  svg {
    margin-right: 15px;
  }

  .red-icon {
    color: $red;
  }

  .green-icon {
    color: $green;
  }

  .yellow-icon {
    color: $orange;
  }

  .blue-icon {
    color: $primary;
  }

  .hide-icon {
    color: #fff;
  }

  .margin_item-bottom {
    margin-bottom: 16px;
  }
  
  &__result {
    .text-center {
      text-align: center;
    }

    &__text {
      font-weight: 500;
      font-size: 12px;
      line-height: 17px;
    }
  }

  &__resultRow {
    margin-bottom: 20px;

    &__text {
      font-weight: 300;
      font-size: 14px;
      line-height: 20px;
    }
  }

  &__batteryDetails {
    margin-top: 20px;

    &__comment {
      &__text {
        font-size: 14px;
      }
    }

    &__row {
      border-bottom: 1px solid $gray-light;
      font-weight: 500;
    }

    &__margin-left {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-end;
      padding-bottom: 10px;
      margin: 16px 18px 0 18px;
      svg {
        margin-right: 10px;
      }
    }
  }
}
</style>
